<template>
  <UserProfile v-if="(profile && profile.user && profile.user.uid)" />
  <UserLogin v-else />
</template>

<script>
import { mapState } from 'vuex'
import UserProfile from '../components/User/UserProfile'
import UserLogin from '../components/User/UserLogin'

export default {
  components: {
    UserLogin,
    UserProfile
  },
  mounted() {
    this.$store.commit('isLoading', false)
  },
  computed: mapState({
    profile: 'profile'
  }),
  methods: {
    onShowHelp() {
      console.log('show help!')
    },
    onShowOrder() {
      console.log('show order!')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue